var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { differenceBy } from 'lodash';
import MOVE_FOLDER from 'api/mutations/MOVE_FOLDER';
import MOVE_MODEL_FOLDER from 'api/mutations/MOVE_MODEL_FOLDER';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import GET_SPECIFICATION_FOLDER_CONTENTS_DATA from 'api/queries/GET_SPECIFICATION_FOLDER_CONTENTS_DATA';
import client from '../api/environment';
const initialState = {
    foldersTree: [],
    currentFolder: '',
    moveFolder: '',
    rootFolder: {
        rootFolderId: null,
        status: 'idle',
        error: null,
    },
    parentFolder: null,
    folders: [],
    status: {
        fetch: 'idle',
        move: 'idle',
    },
    error: {
        fetch: null,
        move: null,
    },
    refetchFlags: {
        fetch: false,
        fetchList: false,
        move: false,
    },
};
export const fetchRootFolder = createAsyncThunk('specificationsMove/fetchRootFolder', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue }) {
    try {
        const response = yield client.query({
            query: GET_CURRENT_TENANT,
            fetchPolicy: 'network-only',
        });
        return response.data.me.currentTenant.rootFolder.id;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchRootFolders = createAsyncThunk('specificationsMove/fetchRootFolders', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ folderId }, { rejectWithValue }) {
    try {
        const response = yield client.query({
            query: GET_SPECIFICATION_FOLDER_CONTENTS_DATA,
            variables: {
                modelSpecificationFolderId: folderId,
                search: '',
                orderBy: '',
                orderName: '',
                othersOrderBy: '',
                tags: [],
                isActive: true,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchSpecificationsFolders = createAsyncThunk('specificationsMove/fetchSpecificationsFolders', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ folderId }, { rejectWithValue }) {
    try {
        const response = yield client.query({
            query: GET_SPECIFICATION_FOLDER_CONTENTS_DATA,
            variables: {
                modelSpecificationFolderId: folderId,
                search: '',
                orderBy: '',
                orderName: '',
                othersOrderBy: '',
                tags: [],
                isActive: true,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const moveSpecification = createAsyncThunk('specificationsMove/moveSpecification', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ modelSpecificationId, modelSpecificationFolderId, }, { rejectWithValue }) {
    var _c, _d, _e, _f;
    try {
        const specifiactionData = yield client.mutate({
            mutation: MOVE_MODEL_FOLDER,
            variables: { modelSpecificationId, modelSpecificationFolderId },
        });
        return specifiactionData;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue((_f = (_e = (_d = (_c = apolloError.graphQLErrors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.extensions) === null || _e === void 0 ? void 0 : _e.exceptionCode) !== null && _f !== void 0 ? _f : apolloError.message);
    }
}));
export const moveFolder = createAsyncThunk('specificationsMove/moveFolder', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ folderToMoveId, destinationFolderId, }, { rejectWithValue }) {
    var _c, _d, _e, _f;
    try {
        const folderData = yield client.mutate({
            mutation: MOVE_FOLDER,
            variables: { folderToMoveId, destinationFolderId },
        });
        return folderData;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue((_f = (_e = (_d = (_c = apolloError.graphQLErrors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.extensions) === null || _e === void 0 ? void 0 : _e.exceptionCode) !== null && _f !== void 0 ? _f : apolloError.message);
    }
}));
const specificationsMoveSlice = createSlice({
    name: 'specificationsMove',
    initialState,
    reducers: {
        setRefetchFlag(state, action) {
            const { flag, value } = action.payload;
            state.refetchFlags[flag] = value;
        },
        resetSpecificationsFolders(state) {
            state.parentFolder = null;
            state.moveFolder = '';
            state.folders = [];
            state.status.fetch = 'idle';
            state.status.move = 'idle';
            state.error.fetch = null;
            state.error.move = null;
        },
        resetFoldersTreeMove(state) {
            state.foldersTree = [];
            state.refetchFlags.fetchList = true;
        },
        setCurrentFolder(state, action) {
            state.currentFolder = action.payload.folderId;
        },
        setMoveFolder(state, action) {
            state.moveFolder = action.payload.folderId;
        },
        toggleIsFolderOpenedMove: (state, action) => {
            const { id } = action.payload;
            const itemIndex = state.foldersTree.findIndex((item) => item.id === id);
            if (itemIndex !== -1) {
                state.foldersTree[itemIndex] = Object.assign(Object.assign({}, state.foldersTree[itemIndex]), { opened: !state.foldersTree[itemIndex].opened });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRootFolder.pending, (state) => {
            state.rootFolder.status = 'loading';
        })
            .addCase(fetchRootFolder.fulfilled, (state, action) => {
            state.rootFolder.rootFolderId = action.payload;
            state.rootFolder.status = 'succeeded';
        })
            .addCase(fetchRootFolder.rejected, (state, action) => {
            state.rootFolder.status = 'failed';
            state.rootFolder.error = action.error.message || 'Error fetching root folder';
        })
            .addCase(fetchRootFolders.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchRootFolders.fulfilled, (state, action) => {
            const fetchedFolders = action.payload.folders.edges.map(({ node }) => {
                return {
                    id: node.id,
                    name: node.name,
                    foldersCount: node.foldersCount,
                    parentId: node.parentFolder.id,
                    opened: false,
                };
            });
            const newFolders = differenceBy(fetchedFolders, state.foldersTree, 'id');
            state.foldersTree = [...state.foldersTree, ...newFolders];
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchRootFolders.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.error.fetch = action.error.message || 'Error fetching specifications folders';
        })
            .addCase(fetchSpecificationsFolders.pending, (state) => {
            state.status.fetch = 'loading';
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchSpecificationsFolders.fulfilled, (state, action) => {
            const fetchedFolders = action.payload.folders.edges.map(({ node }) => {
                return {
                    id: node.id,
                    name: node.name,
                    foldersCount: node.foldersCount,
                    modelSpecificationsCount: node.modelSpecificationsCount,
                    canBeRemoved: node.canBeRemoved,
                    parentId: node.parentFolder.id,
                    opened: false,
                };
            });
            const newFolders = differenceBy(fetchedFolders, state.foldersTree, 'id');
            state.foldersTree = [...state.foldersTree, ...newFolders];
            state.parentFolder = action.payload.parentFolder;
            state.folders = fetchedFolders;
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchSpecificationsFolders.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.error.fetch = action.error.message || 'Error fetching specifications folders';
        })
            .addCase(moveSpecification.pending, (state) => {
            state.status.move = 'loading';
        })
            .addCase(moveSpecification.fulfilled, (state) => {
            state.status.move = 'succeeded';
            state.refetchFlags.fetch = true;
        })
            .addCase(moveSpecification.rejected, (state, action) => {
            state.status.move = 'failed';
            state.error.move = action.error.message || 'Error fetching specifications folders';
        })
            .addCase(moveFolder.pending, (state) => {
            state.status.move = 'loading';
        })
            .addCase(moveFolder.fulfilled, (state) => {
            state.status.move = 'succeeded';
            state.refetchFlags.fetch = true;
        })
            .addCase(moveFolder.rejected, (state, action) => {
            state.status.move = 'failed';
            state.error.move = action.error.message || 'Error fetching specifications folders';
        });
    },
});
export const { resetFoldersTreeMove, setRefetchFlag, resetSpecificationsFolders, setCurrentFolder, setMoveFolder, toggleIsFolderOpenedMove, } = specificationsMoveSlice.actions;
export const selectRootFolder = (state) => state.specificationsMove.rootFolder;
export const selectCurrentFolder = (state) => state.specificationsMove.currentFolder;
export const selectMoveFolder = (state) => state.specificationsMove.moveFolder;
export const selectParentFolder = (state) => state.specificationsMove.parentFolder;
export const selectFoldersTree = (state) => state.specificationsMove.foldersTree;
export const selectIsFolderOpenedMove = (state, folderId) => {
    var _a;
    const foldersTree = (_a = state.specificationsMove) === null || _a === void 0 ? void 0 : _a.foldersTree;
    if (!foldersTree || !Array.isArray(foldersTree)) {
        return false;
    }
    const folder = foldersTree.find((folder) => folder.id === folderId);
    return folder === null || folder === void 0 ? void 0 : folder.opened;
};
export const selectFolderName = (state, folderId) => { var _a, _b; return ((_b = (_a = state.specificationsMove.foldersTree) === null || _a === void 0 ? void 0 : _a.find((folder) => folder.id === folderId)) === null || _b === void 0 ? void 0 : _b.name) || ''; };
export const selectStatus = (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.specificationsMove) === null || _a === void 0 ? void 0 : _a.status; };
export default specificationsMoveSlice.reducer;
